import type { SVGProps } from 'react'
const SvgSyArrowDown3 = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M12.252 3a.75.75 0 0 0-.75.75v8.95a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V3.75a.75.75 0 0 0-.75-.75"
				opacity={0.4}
			/>
			<path
				fillRule="evenodd"
				d="M7.25 11.95a.75.75 0 0 0-.635 1.15l5.002 7.937a.75.75 0 0 0 1.27 0l5-7.937a.75.75 0 0 0-.635-1.15zm1.36 1.5h7.285l-3.643 5.779z"
				clipRule="evenodd"
			/>
		</g>
	</svg>
)
export default SvgSyArrowDown3
